"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFlashingTargetViewItems = void 0;
const getFlashingTargetViewItems = (flashingCell) => {
    return {
        name: 'Target',
        values: Array.isArray(flashingCell.FlashTarget)
            ? flashingCell.FlashTarget
            : [flashingCell.FlashTarget],
    };
};
exports.getFlashingTargetViewItems = getFlashingTargetViewItems;
